/* eslint-disable @typescript-eslint/no-explicit-any */
export class SnackbarConfig {
  icon?: string;
  type: 'info' | 'success' | 'warning' | 'error' | 'plain' = 'info';
  title?: string;
  description?: string;
  duration = 5000;
  position:
    | 'top-left'
    | 'top'
    | 'top-right'
    | 'bottom-left'
    | 'bottom'
    | 'bottom-right' = 'bottom';
}
